const placeholder = '--defaultName--';

export function processContentTitle(contentTitle: string, defaultName: string) {
    return contentTitle.replace(placeholder, defaultName);
}
